<template>
    <div class="footer">
        <div class="main-wrap">
            <div class="top-foot">
                <div class="fl foot-info">
                    <a href="http://mrml.mingrenminglan.com/mrml/index.html#/index" class="url">http://mrml.mingrenminglan.com/mrml/index.html#/index</a>
                    <p class="company">成都引领名兰科技有限公司</p>
                    <p class="line"><span></span><span></span></p>
                    <p class="tel"><i class="el-icon-phone-outline"></i>02886980605</p>
                    <p class="address">公司地址：四川省成都市天府新区华阳街道东华巷66号1栋1单元1层66号</p>
                </div>
                <div class="fr down-app">
                    <img src="../assets/images/qrCode.png" alt="">
                    <p>APP下载</p>
                </div>
            </div>
            <p class="record">©2020 成都引领名兰科技有限公司 | 蜀ICP备20014314号</p>
            <div style="width:300px;margin:0 auto; padding:20px 0;">
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002003163" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                    <img src="../assets/images/beian.png" style="float:left;" />
                    <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color: #ffffff;">川公网安备 51019002003163号</p >
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'footers',
        data(){
            return {

            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import '../assets/css/common';
   .footer{
       background:url("../assets/images/bg-footer.png")no-repeat center;
       color:#ffffff;
       -webkit-background-size: cover;
       background-size: cover;
       .top-foot{
           overflow: hidden;
           .foot-info{
               padding-top:46px;
               .url{font-size:14px;color:#ffffff;
                   line-height: 30px;}
               .company{font-size:20px;}
               .line{
                   padding:12px 0 22px;
                   font-size: 0;
                   span{
                       display: inline-block;
                       width:60px;
                       height:3px;
                       &:first-child{background-color:$main-color}
                       &:last-child{background-color:#ffffff;}
                   }
               }
               .tel{
                   i{
                       width: 40px;
                       height: 40px;
                       line-height: 40px;
                       text-align: center;
                       margin-right: 22px;
                       border: 2px solid #ffffff;
                       border-radius: 50%;
                       font-size: 24px;}
                   font-size:30px;}
               .address{font-size:14px;padding-top:17px;}
           }
           .down-app{
               width:145px;
               text-align: center;
               margin-top: 50px;
               img{
                   width:120px;
                   height:120px;
               }
               p{font-size:14px;
                   padding-top: 12px;}

           }
       }
       .record{padding:40px 0 0;font-size:12px;text-align:center;  }
   }


</style>
